import axios from 'axios';
import { UpdateAeratorInput } from 'views/self-service/features/aerators/types/update-aerator-input.type';

// PUT Aerator
// /ewosapi/v1/shrimps/aerator/{globalCompanyId}/${aeratorId}
export const putAerator = async (globalCompanyId: string, aeratorId: number, request: UpdateAeratorInput) => {
  const res = await axios.put(`/ewosapi/v1/shrimps/aerator/${globalCompanyId}/${aeratorId}`, request);
  return res.data;
};
